<template>
    <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <div class="Info_Area">
      <b-card no-body>
        <b-tabs v-model="tabnum" card>
          <b-tab
            v-for="(item, index) in items"
            :key="index"
            :title="item.title"
          >
        <OpenInfoTemplate 
          :purpose="item.purpose"
          :basicinfoitems="item.basicinfoitems"
          :responseinfoitems="item.responseinfoitems"
          :responseinfowitparamitems="item.responseinfowitparamitems"
        />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import OpenInfoTemplate from "../components/OpenInfoTemplate.vue";
import OpenInfoData from "../data/OPEN_API_INFO.json"

export default {
  name: "OpenInfo",
  data() {
    return {
        breadcrumbItems: 
        [
          {
              text: "首頁",
              href: "#/",
          },
          {
              text: '資訊服務',
              active: true
          }
        ],
        items: OpenInfoData,
        tabnum: 0
      }
  },
  components: {
    OpenInfoTemplate
  },
  created() {
    console.log(this.items)
  }
  // updated() {},
  // mounted() {},
  // methods: {}
}
</script>
<style lang="scss">
.logo {
  height: 48px;
}
</style>
